<template>
  <button
      v-on:click="buttonAction()"
      type="button"
      class="btn sam-secondary-button"
      :class="[{ 'mb-4': !noSpace && !customClass.includes('mb-') }, customClass]"
      :disabled="disabled === true || loading === true"
  >
    <template v-if="loading">
      <!-- Show spinner when loading -->
      <span class="spinner"></span>
    </template>
    <template v-else>
      <!-- Show button text when not loading -->
      {{ text }}
    </template>
  </button>
</template>

<script>
export default {
  name: 'SamSecondaryButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: ''
    },
    noSpace: {
      type: Boolean,
      default: false,
    },
    toggleModal: {
      type: Boolean,
      default: false
    },
    modalId: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    loading: { // Add loading prop to control spinner visibility
      type: Boolean,
      default: false
    }
  },
  methods: {
    buttonAction() {
      this.$emit('buttonAction');
    },
  }
}
</script>

<style lang="scss" scoped>
.btn.sam-secondary-button, .btn.sam-secondary-button:focus {
  background: $lightGrey !important;
  color: $almostBlack;
  border: none;
  height: $regularButtonHeight;
  width: $regularButtonWidth;
  transition: $mainTransition;
  font-family: $boldFontStyle;
  border-radius: $mainRadius;
}

.sam-secondary-button:hover {
  opacity: $hoverOpacity;
}

.sam-secondary-button:disabled {
  opacity: $disableOpacity;
}

/* Spinner style */
.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: $almostBlack;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
